(function () {
  var root = document.querySelector('[data-lenny-home]');
  if (!root) return;

  var intro = root.querySelector('[data-lenny-intro]');
  var enter = root.querySelector('[data-lenny-enter]');

  function finishIntro() {
    if (!intro) return;
    intro.classList.add('is-done');
    document.body.classList.remove('intro-lock');
  }

  if (intro) {
    document.body.classList.add('intro-lock');
    window.setTimeout(finishIntro, 6000);
    if (enter) enter.addEventListener('click', finishIntro);
  }

  var reveals = Array.prototype.slice.call(root.querySelectorAll('.reveal'));
  if (!('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12 });

  reveals.forEach(function (el) { observer.observe(el); });
})();

(function () {
  var nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;

  var toggle = nav.querySelector('[data-mobile-nav-toggle]');
  var panel = nav.querySelector('[data-mobile-nav-panel]');
  if (!toggle || !panel) return;

  function setOpen(open) {
    nav.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('lenny-mobile-menu-open', open);
  }

  toggle.addEventListener('click', function () {
    setOpen(!nav.classList.contains('is-open'));
  });

  panel.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () { setOpen(false); });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });

  document.addEventListener('click', function (event) {
    if (!nav.classList.contains('is-open')) return;
    if (nav.contains(event.target)) return;
    setOpen(false);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 760) setOpen(false);
  });
})();
